import React, { useState } from 'react';
import { Loader, Modal } from '../../components';
import "./download-excel.css";
import { downloadExcel } from '../../service/downlaod-excel';
import { STRINGS } from '../../comman/constants';

export default function DownloadExcel() {
    const [enterPassword, setEnterPassword] = useState(false);
    const [secureKey, setSecureKey] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const checkDate = () => {
        if (new Date(startDate) > new Date(endDate)) {
            setErrorMessage(STRINGS.downloadExcel.startDateError);
        } else {
            setErrorMessage("");
            setEnterPassword(true);
        }
    };

    async function fetchData(password) {
        try {
            setIsLoading(true);
            if (password !== "") {
                const response = await downloadExcel(startDate, endDate, password);
                if (response.status === 200) {
                    const responseData = response.data?.data || response.data;
                    let url = `${"https://api.myflexa.ru/v1/common/media/signed-url?fileKey="}${responseData.slug}`;
                    downloadXLSX(url);
                } else {
                    throw new Error(`Request failed with status ${response.status}`);
                }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    }

    const downloadXLSX = (fileUrl) => {
        window.location.href = fileUrl;
    };

    return (
        isLoading ? (
            <Loader />
        ) : (
            <>
                <div className="download-excel-container">
                    <div className="date-picker-container">
                        <div className="date-picker">
                            <label htmlFor="startDate" className="label">{STRINGS.downloadExcel.startDate}</label>
                            <input
                                className="input"
                                type="date"
                                value={startDate}
                                onChange={(e) => { setStartDate(e.target.value); setErrorMessage(""); }}
                                id="startDate"
                            />
                        </div>

                        <div className="date-picker">
                            <label htmlFor="endDate" className="label">{STRINGS.downloadExcel.endDate}</label>
                            <input
                                className="input"
                                type="date"
                                value={endDate}
                                onChange={(e) => { setEndDate(e.target.value); setErrorMessage(""); }}
                                id="endDate"
                            />
                        </div>
                    </div>
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                    <button
                        disabled={startDate === "" || endDate === ""}
                        onClick={() => checkDate()}
                        className="download-btn"
                    >
                        {STRINGS.downloadExcel.downloadBtn}
                    </button>
                </div>

                <Modal width="500px" show={enterPassword} onClose={() => setEnterPassword(false)}>
                    <div className="modal-content">
                        <p className="modal-message">{STRINGS.downloadExcel.enterPasswordMsg}</p>
                        <div className="password-input-container">
                            <input
                                value={secureKey}
                                onChange={(e) => setSecureKey(e.target.value)}
                                type={showPassword ? "text" : "password"}
                                className="password-input"
                                placeholder={STRINGS.downloadExcel.passwordPlaceholder}
                            />

                            <button
                                type="button"
                                onClick={togglePasswordVisibility}
                                className="password-visibility-toggle"
                            >
                                {showPassword ? STRINGS.downloadExcel.hide : STRINGS.downloadExcel.show}
                            </button>
                        </div>

                        <button
                            onClick={() => fetchData(secureKey)}
                            className="download-btn"
                        >
                            {STRINGS.downloadExcel.downloadBtn}
                        </button>
                    </div>
                </Modal>
            </>
        )
    );
}
